import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from '../../../../../store/modules/ModalActions';
import { getElementID } from '../../../../../utils/HTMLUtils';
import { Col } from '../../../../../components/Col';
import { CustomButton } from '../../../../../components/CustomButton';
import { GenericModal } from '../../../../../components/GenericModal';
import SaveIcon from '../../../../../components/Icons/SaveIcon';
import { Row } from '../../../../../components/Row';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { changeContratoEntePrivadoEditingValue } from '../../../../../store/modules/ContratosEntePrivadoActions';
import styles from './CadastroAnexoIModal.scss';
import CustomCurrencyField from '../../../../../components/CustomCurrencyField/CustomCurrencyField';

const rootClassName = styles.rootClassName;
const rootElementId = 'cadastro-anexo-i-modal';

const MAX_SIZE_INPUTS = 2000;

const INITIAL_STATE = {
  index: -1,
  como: '',
  comoChanged: false,
  custoEstimado: '',
  custoEstimadoChanged: false,
  id: 0,
  idChanged: false,
  idLinhaOrcamentaria: 0,
  idLinhaOrcamentariaChanged: false,
  nomeLinhaOrcamentaria: '',
  nomeLinhaOrcamentariaChanged: false,
  onde: '',
  ondeChanged: false,
  oque: '',
  oqueChanged: false,
  porque: '',
  porqueChanged: false,
  quando: '',
  quandoChanged: false,
  quem: '',
  quemChanged: false,
  planosTrabalhoArr: [],
};

class CadastroAnexoIModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      ...(this.props.planoTrabalho || {}),
      planosTrabalhoArr: this.props.contratosEntePrivado.contratoEditing
        .planoTrabalho
        ? this.props.contratosEntePrivado.contratoEditing.planoTrabalho
        : [],
    };
  }

  toClose = () => {
    this.props.closeModal(this.props.modalKey);
  };

  toCancel = () => {
    if (typeof this.props.cancelCallback === 'function') {
      this.props.cancelCallback();
    }
    this.toClose();
  };

  toConfirm = () => {
    this.props.savedCallback({
      index: this.state.index,
      como: this.state.como,
      custoEstimado: this.state.custoEstimado,
      id: this.state.id,
      idLinhaOrcamentaria: this.state.idLinhaOrcamentaria,
      nomeLinhaOrcamentaria: this.state.nomeLinhaOrcamentaria,
      onde: this.state.onde,
      oque: this.state.oque,
      porque: this.state.porque,
      quando: this.state.quando,
      quem: this.state.quem,
    });
    this.toClose();
  };

  linhaOrcamentariaIsValid() {
    if (this.state.idLinhaOrcamentaria !== -1) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  oqueIsValid() {
    if (this.state.oque !== INITIAL_STATE.oque) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  quandoIsValid() {
    if (this.state.quando !== INITIAL_STATE.quando) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  quemIsValid() {
    if (this.state.quem !== INITIAL_STATE.quem) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  porqueIsValid() {
    if (this.state.porque !== INITIAL_STATE.porque) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  ondeIsValid() {
    if (this.state.onde !== INITIAL_STATE.onde) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  comoIsValid() {
    if (this.state.como !== INITIAL_STATE.como) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  buttomIsDisabled() {
    if (
      this.linhaOrcamentariaIsValid().status &&
      this.oqueIsValid().status &&
      this.quandoIsValid().status &&
      this.quemIsValid().status &&
      this.porqueIsValid().status &&
      this.ondeIsValid().status &&
      this.comoIsValid().status
    ) {
      if (
        this.state.idLinhaOrcamentaria === -1 ||
        this.state.idLinhaOrcamentaria === 0 ||
        this.state.oque === null ||
        this.state.quando === null ||
        this.state.quem === null ||
        this.state.porque === null ||
        this.state.onde === null ||
        this.state.como === null
      ) {
        return {
          status: true,
        };
      }
      return {
        status: false,
      };
    } else {
      return {
        status: true,
      };
    }
  }

  render() {
    return (
      <GenericModal
        id={rootElementId}
        onClose={this.toCancel}
        DialogProps={{
          maxWidth: 'sm',
          disableBackdropClick: true,
          disableEscapeKeyDown: true,
        }}
        title={this.props.languageValues.cadastroPlanoTrabalhoModalTitle}
        footerContent={
          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomButton
                id={getElementID(rootElementId, 'cancel')}
                theme='pufvYellow'
                className={rootClassName + '-cancel-button'}
                label={this.props.languageValues.cancelButton}
                onClick={this.toCancel}
              />
            </Col>
            <Col className={rootClassName} cols={[12, 12, 6, 6, 6]}>
              <CustomButton
                id={getElementID(rootElementId, 'confirm')}
                theme='sicrediGreen'
                className={rootClassName + '-confirm-buttom'}
                label={
                  this.props.languageValues.cadastroPlanoTrabalhoButtomLabel
                }
                rightIcon={<SaveIcon />}
                onClick={this.toConfirm}
                disabled={this.buttomIsDisabled().status}
              />
            </Col>
          </Row>
        }
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <NewAutoCompleteField
              id={getElementID(rootElementId, 'linhaOrcamentaria')}
              placeholder={
                this.props.contratosEntePrivado.loadingLinhasOrcamentarias
                  ? this.props.languageValues.loadingLinhasOrcamentaria
                  : this.props.languageValues.loadedLinhasOrcamentaria
              }
              label={this.props.languageValues.linhaOrcamentariaLabel}
              options={(
                this.props.contratosEntePrivado.linhasOrcamentarias || []
              ).map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              value={this.state.idLinhaOrcamentaria}
              onChange={(value) => {
                this.setState({
                  idLinhaOrcamentaria: value ? value.value : -1,
                  idLinhaOrcamentariaChanged: true,
                  nomeLinhaOrcamentaria: value ? value.label : '',
                  nomeLinhaOrcamentariaChanged: true,
                });
              }}
              error={
                this.state.idLinhaOrcamentariaChanged &&
                !this.linhaOrcamentariaIsValid().status
              }
              helperText={
                this.state.idLinhaOrcamentariaChanged &&
                !this.linhaOrcamentariaIsValid().status
                  ? this.props.languageValues.emptyLinhaOrcamentaria
                  : ''
              }
            />
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'oque')}
              label={this.props.languageValues.oqueLabel}
              name='oque'
              value={this.state.oque}
              onChange={(event) => {
                this.setState({
                  oque: event.target.value,
                  oqueChanged: true,
                });
              }}
              counter={true}
              maxSize={MAX_SIZE_INPUTS}
              error={this.state.oqueChanged && !this.oqueIsValid().status}
              helperText={
                this.state.oqueChanged && !this.oqueIsValid().status
                  ? this.props.languageValues.emptyOque
                  : ''
              }
            />
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'quando')}
              label={this.props.languageValues.quandoLabel}
              name='quando'
              value={this.state.quando}
              onChange={(event) => {
                this.setState({
                  quando: event.target.value,
                  quandoChanged: true,
                });
              }}
              counter={true}
              maxSize={MAX_SIZE_INPUTS}
              error={this.state.quandoChanged && !this.quandoIsValid().status}
              helperText={
                this.state.quandoChanged && !this.quandoIsValid().status
                  ? this.props.languageValues.emptyQuando
                  : ''
              }
            />
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'quem')}
              label={this.props.languageValues.quemLabel}
              name='quem'
              value={this.state.quem}
              onChange={(event) => {
                this.setState({
                  quem: event.target.value,
                  quemChanged: true,
                });
              }}
              counter={true}
              maxSize={MAX_SIZE_INPUTS}
              error={this.state.quemChanged && !this.quemIsValid().status}
              helperText={
                this.state.quemChanged && !this.quemIsValid().status
                  ? this.props.languageValues.emptyQuem
                  : ''
              }
            />
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'porque')}
              label={this.props.languageValues.porqueLabel}
              name='porque'
              value={this.state.porque}
              onChange={(event) => {
                this.setState({
                  porque: event.target.value,
                  porqueChanged: true,
                });
              }}
              counter={true}
              maxSize={MAX_SIZE_INPUTS}
              error={this.state.porqueChanged && !this.porqueIsValid().status}
              helperText={
                this.state.porqueChanged && !this.porqueIsValid().status
                  ? this.props.languageValues.emptyPorque
                  : ''
              }
            />
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'onde')}
              label={this.props.languageValues.ondeLabel}
              name='onde'
              value={this.state.onde}
              onChange={(event) => {
                this.setState({
                  onde: event.target.value,
                  ondeChanged: true,
                });
              }}
              counter={true}
              maxSize={MAX_SIZE_INPUTS}
              error={this.state.ondeChanged && !this.ondeIsValid().status}
              helperText={
                this.state.ondeChanged && !this.ondeIsValid().status
                  ? this.props.languageValues.emptyOnde
                  : ''
              }
            />
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'como')}
              label={this.props.languageValues.comoLabel}
              name='como'
              value={this.state.como}
              onChange={(event) => {
                this.setState({
                  como: event.target.value,
                  comoChanged: true,
                });
              }}
              counter={true}
              maxSize={MAX_SIZE_INPUTS}
              error={this.state.comoChanged && !this.comoIsValid().status}
              helperText={
                this.state.comoChanged && !this.comoIsValid().status
                  ? this.props.languageValues.emptyComo
                  : ''
              }
            />
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomCurrencyField
              id={getElementID(rootElementId, 'custo-estimado')}
              label={this.props.languageValues.custoEstimadoLabel}
              name='custoEstimado'
              value={this.state.custoEstimado}
              onChange={(value) => {
                this.setState({
                  custoEstimado: value,
                  custoEstimadoChanged: true,
                });
              }}
              error={false}
              helperText={false}
              disabled={false}
            />
          </Col>
        </Row>
      </GenericModal>
    );
  }
}

CadastroAnexoIModal.propTypes = {
  planosTrabalho: PropTypes.object,
  savedCallback: PropTypes.func.isRequired,
  cancelCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratosEntePrivado: state.contratosEntePrivado,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
      changeContratoEntePrivadoEditingValue,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CadastroAnexoIModal);
